module.exports = __webpack_public_path__ + "static/media/mirror_la.a6ea7af9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/personal/normals/mirror_la.jpg
// module id = 423
// module chunks = 0